import { Component,  ElementRef,  inject,  model, signal, ViewChild } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

import { ISeriesEntry } from 'src/app/_models';
import { SeriesInputComponent } from '../series-input/series-input.component';
import { LogService, MessageService } from 'src/app/services';


@Component({
    selector: 'kbm-series-list',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatChipsModule,     
        SeriesInputComponent   
    ],
    templateUrl: './series-list.component.html',
    styleUrls: ['./series-list.component.scss']
})
export class SeriesListComponent {

  series = model.required<ISeriesEntry[] | null>();

  logService     = inject(LogService);
  messageService = inject(MessageService);

  visible = true;
  selectable = false;
  removable = true;
  addOnBlur = false;

  removeSeriesEvt(row: number) {
    this.series.update(series => {
      series!.splice(row, 1);
      return series;
    })
  }

  onNewSeries(evt: any) {
   // this.logService.debug('onNewSeries', evt);
    this.series.set(evt);
  }


}
